import React from 'react'
import { Parallax, ParallaxBanner } from 'react-scroll-parallax'
import { Trans } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'

const Employees: React.FC = () => {
	return (
		<section className={styles.section}>
			<div className={styles.sectionFixed}>
				<ParallaxBanner
					className={styles.parallaxBanner}
					layers={[
						{
							amount: -0.1,
							// expanded: false,
							children: (
								<div
									className={`${styles.bubble} ${styles.bubbleCirclePink}`}
									style={{
										animation: 'shake 40s 12s'
									}}
								/>
							)
						},
						{
							amount: 0.1,
							// expanded: false,
							children: (
								<div
									className={`${styles.bubble} ${styles.bubbleCircleBlack}`}
									style={{
										animation: 'shake 40s 11s'
									}}
								/>
							)
						},
						{
							amount: 0.05,
							// expanded: false,
							children: (
								<img
									src="/2021/images/employees/1.png"
									className={`${styles.bubble} ${styles.bubble1}`}
									alt=""
									style={{
										animation: 'shake 40s 9s'
									}}
								/>
							)
						},
						{
							amount: -0.1,
							// expanded: false,
							children: (
								<img
									src="/2021/images/employees/2.png"
									className={`${styles.bubble} ${styles.bubble2}`}
									alt=""
									style={{
										animation: 'shake 40s 8s'
									}}
								/>
							)
						},
						{
							amount: 0.1,
							// expanded: false,
							children: (
								<img
									src="/2021/images/employees/3.png"
									className={`${styles.bubble} ${styles.bubble3}`}
									alt=""
									style={{
										animation: 'shake 40s 7s'
									}}
								/>
							)
						},
						{
							amount: -0.15,
							// expanded: false,
							children: (
								<img
									src="/2021/images/employees/4.png"
									className={`${styles.bubble} ${styles.bubble4}`}
									alt=""
									style={{
										animation: 'shake 40s 5s'
									}}
								/>
							)
						},
						{
							amount: 0.05,
							// expanded: false,
							children: (
								<img
									src="/2021/images/employees/5.png"
									className={`${styles.bubble} ${styles.bubble5}`}
									alt=""
									style={{
										animation: 'shake 40s 4s'
									}}
								/>
							)
						},
						{
							amount: 0.25,
							// expanded: false,
							children: (
								<div
									className={`${styles.bubble} ${styles.bubblePink}`}
									style={{
										animation: 'shake 40s'
									}}
								>
									<Trans
										i18nKey="employees.have"
										components={[
											<span className="h2 mb-1" />,
											<h4 className="display-2 font-weight-bold mb-0" />,
											<span className="h2" />
										]}
									/>
								</div>
							)
						},
						{
							amount: 0.2,
							// expanded: false,
							children: (
								<div
									className={`${styles.bubble} ${styles.bubbleBlack}`}
									style={{
										animation: 'shake 40s 2s'
									}}
								>
									<Trans
										i18nKey="employees.speak"
										components={[
											<span className="h2 mb-1" />,
											<h4 className="display-2 font-weight-bold mb-0" />,
											<span className="h2" />
										]}
									/>
								</div>
							)
						}
					]}
				></ParallaxBanner>
				{/* <img
					src="/2021/images/employees/3.png"
					className={`${styles.bubble} ${styles.bubble3}`}
					alt=""
				/>
				<img
					src="/2021/images/employees/4.png"
					className={`${styles.bubble} ${styles.bubble4}`}
					alt=""
				/>
				<img
					src="/2021/images/employees/5.png"
					className={`${styles.bubble} ${styles.bubble5}`}
					alt=""
				/> */}
				{/* <div className={`${styles.bubble} ${styles.bubbleCirclePink}`} />
				<div className={`${styles.bubble} ${styles.bubbleCircleBlack}`} />
				<div className={`${styles.bubble} ${styles.bubblePink}`}>
					<span className="h2 mb-1">Máme</span>
					<h4 className="display-2 font-weight-bold mb-0">1&nbsp;800</h4>
					<span className="h2">zaměstnanců</span>
				</div>
				<div className={`${styles.bubble} ${styles.bubbleBlack}`}>
					<span className="h2 mb-1">Mluví</span>
					<h4 className="display-2 font-weight-bold mb-0">19</h4>
					<span className="h2">jazyky</span>
				</div> */}
			</div>
		</section>
	)
}

export default Employees
